import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import InputAdornment from '@material-ui/core/InputAdornment';
import SearchIcon from '@material-ui/icons/Search';
import MenuItem from '@material-ui/core/MenuItem';
import { instanceAxios } from '../InstanceAxios';

const columns = [
  { title: 'Razão Social', field: 'razao_social' },
  { title: 'Nome Cliente', field: 'nome_cliente' },
  { title: 'CNPJ', field: 'cnpj' },
];

const useStyles = makeStyles({
  root: {
    width: '100%',
  },
  container: {
    maxHeight: 440,
  },
});

export default function StickyHeadTable(props) {
  const classes = useStyles();
  const [company, setCompany] = React.useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [countItens, setCountItens] = React.useState(0);
  const [offset, setOffset] = React.useState(0);
  const [searchCompany, setSearchCompany] = React.useState('');
  const [searchClient, setSearchClient] = React.useState('');
  const [modalListOfCompany, setModalListOfCompany] = useState(false);
  const [assinantes, setAssinantes] = useState(
    props.assinantes ? props.assinantes : false
  );

  useEffect(() => {
    const fetchUsernames = async () => {
      setLoading(true);
      await instanceAxios(localStorage.getItem('toobiauth'))
        .get(
          `/empresas?offset=${offset}&razaoSocial=${searchCompany}&assinantes=${assinantes}`
        )
        .then((res) => {
          setCompany(res.data.rows);
          setCountItens(res.data.count);
        })
        .catch((err) => {
          console.log(err);
        });
      setLoading(false);
    };

    fetchUsernames();
  }, [offset]); //eslint-disable-line

  const handleChangePage = async (event, newPage) => {
    if (newPage > page) {
      setOffset(offset + 10);
    } else {
      setOffset(offset - 10);
    }
    setPage(newPage);
  };

  const modal = () => {
    return (
      <Modal
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        open={modalListOfCompany}
        onClose={() => setModalListOfCompany(false)}
      >
        {loading ? (
          <Backdrop open={loading}>
            <CircularProgress color="inherit" />
          </Backdrop>
        ) : (
          <div
            style={{
              width: '90%',
              position: 'absolute',
              top: '5%',
              left: '6%',
              height: '100%',
            }}
          >
            <div
              style={{
                backgroundColor: '#FFF',
                paddingRight: 15,
                paddingBottom: 10,
              }}
            >
              <Grid container spacing={3}>
                <Grid item xs={5}>
                  <div align="right">
                    <TextField
                      id="busca_empresa"
                      label="Pesquise por uma Empresa"
                      value={searchCompany}
                      onChange={async (event) => {
                        setOffset(0);
                        setPage(0);
                        setSearchCompany(event.target.value);
                        setSearchClient('');
                        await instanceAxios(localStorage.getItem('toobiauth'))
                          .get(
                            `/empresas?offset=${offset}&razaoSocial=${event.target.value}&assinantes=${assinantes}&cnpj=${event.target.value}`
                          )
                          .then((res) => {
                            setCompany(res.data.rows);
                            setCountItens(res.data.count);
                          });
                      }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchIcon />
                          </InputAdornment>
                        ),
                      }}
                      style={{ width: '70%' }}
                    />
                  </div>
                </Grid>
                <Grid item xs={2}>
                  <div align="center">
                    <Typography>OU</Typography>
                  </div>
                </Grid>
                <Grid item xs={5}>
                  <div align="left">
                    <TextField
                      id="busca_cliente"
                      label="Pesquise por uma Nome do Cliente"
                      value={searchClient}
                      onChange={async (event) => {
                        setSearchCompany('');
                        setOffset(0);
                        setPage(0);
                        setSearchClient(event.target.value);
                        await instanceAxios(localStorage.getItem('toobiauth'))
                          .get(
                            `/empresas?offset=${offset}&assinantes=${assinantes}&nomeCliente=${event.target.value}`
                          )
                          .then((res) => {
                            setCompany(res.data.rows);
                            setCountItens(res.data.count);
                          });
                      }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchIcon />
                          </InputAdornment>
                        ),
                      }}
                      style={{ width: '70%' }}
                    />
                  </div>
                </Grid>
              </Grid>
            </div>
            <Paper className={classes.root}>
              <TableContainer className={classes.container}>
                <Table stickyHeader aria-label="sticky table">
                  <TableHead>
                    <TableRow>
                      {columns.map((column) => (
                        <TableCell
                          key={column.id}
                          align="center"
                          style={{ minWidth: column.minWidth }}
                        >
                          {column.title}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {company.map((row) => {
                      return (
                        <TableRow
                          hover
                          role="checkbox"
                          tabIndex={-1}
                          key={row.code}
                          onClick={() => {
                            props.setCompanySelect(row.razao_social);
                            if (props.setIdEmpresa) props.setIdEmpresa(row.id);
                            if (props.setCnpj) props.setCnpj(row.cnpj);
                            if (props.setObjEmpresa) props.setObjEmpresa(row);
                            setModalListOfCompany(false);
                          }}
                        >
                          {columns.map((column) => {
                            const value = column.field.includes('nome_cliente')
                              ? row.UsuarioEmpresa?.User.nome
                              : row[column.field];
                            return (
                              <TableCell key={column.field} align="center">
                                {value}
                              </TableCell>
                            );
                          })}
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                rowsPerPageOptions={[10]}
                component="div"
                count={countItens}
                style={{ backgroundColor: '#FFF' }}
                rowsPerPage={rowsPerPage}
                page={page}
                onChangePage={handleChangePage}
              />
            </Paper>
          </div>
        )}
      </Modal>
    );
  };

  return (
    <>
      {modal()}
      <TextField
        id="standard-select-currency"
        select
        SelectProps={{ open: false, onOpen: () => setModalListOfCompany(true) }}
        style={{ margin: 8, width: props.width }}
        label={`${props.label}`}
        value={props.companySelect}
        InputLabelProps={{
          shrink: true,
        }}
        onChange={(event, value) => {}}
        error={props.error}
      >
        {company.map((option) => (
          <MenuItem key={option.id} value={option.razao_social}>
            {option.razao_social}
          </MenuItem>
        ))}
      </TextField>
    </>
  );
}
